
import { useMutation } from 'react-query';
import {
  createTotvsIENHIntegrationAsync,
  deleteTotvsIENHIntegrationAsync,
  getAllTotvsIENHIntegrationsAsync,
  getTotvsIENHIntegrationByIdAsync,
  updateTotvsIENHIntegrationAsync,
} from '../../index';

export const useCreateTotvsIntegrationAsync = () =>
  useMutation(createTotvsIENHIntegrationAsync);

export const useGetTotvsIntegrationByIdAsync = () =>
  useMutation(getTotvsIENHIntegrationByIdAsync);

export const useGetAllTotvsIntegrationsAsync = () =>
  useMutation(getAllTotvsIENHIntegrationsAsync);

export const useUpdateTotvsIntegrationAsync = () =>
  useMutation(updateTotvsIENHIntegrationAsync);

export const useDeleteTotvsIENHIntegrationAsync = () =>
  useMutation(deleteTotvsIENHIntegrationAsync);
